import { ButtonDisplay } from './ButtonDisplay'
import { SelectDisplay } from './SelectDisplay'
import { TextDisplay } from './TextDisplay'
import type { DatePickerDisplayTypes, DisplayProps } from './types'

export { DatePickerDisplayTypes, DisplayProps }
export { DatePickerStyleSelectors, DatePickerStyleStates } from './styles'

type Displays = Record<DatePickerDisplayTypes, React.FC<DisplayProps>>

export const displays: Displays = {
  button: ButtonDisplay,
  select: SelectDisplay,
  text: TextDisplay,
}
